import { RichTextAdvancedInput } from '@framework/engine/inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { CommonConfigComponent } from '@framework/engine/schema/widgets/repository/inputs/common/CommonInputConfigComponent.tsx';
import { getWidgetProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Divider } from 'antd';
import { type IEmailVerificationWidget } from './IEmailVerificationWidget.ts';

export interface IEmailVerificationWidgetConfigComponentProps
  extends IWidgetComponentProps<IEmailVerificationWidget> {}

export function EmailVerificationWidgetConfigComponent(
  props: IEmailVerificationWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <div>
      {/* Configurazioni comuni */}
      <CommonConfigComponent {...props} noConfirmation hideConfigHelpText />

      {/* Configurazione testi prima fase */}
      <Divider orientation="left" orientationMargin={0}>
        1 | Avvio verifica
      </Divider>
      <FormItem name="layout.startButtonText" label="Testo pulsante iniziale">
        <TextInput name="layout.startButtonText" />
      </FormItem>
      <FormItem name="layout.startHelpText" label="Testo di aiuto iniziale">
        <RichTextAdvancedInput
          name="layout.startHelpText"
          menus={MenuPresets.Minimal}
          rows={3}
        />
      </FormItem>

      {/* Configurazione testi seconda fase */}
      <Divider orientation="left" orientationMargin={0}>
        2 | Controllo validità
      </Divider>
      <FormItem name="layout.endButtonText" label="Testo pulsante verifica">
        <TextInput name="layout.endButtonText" />
      </FormItem>
      <FormItem name="layout.endHelpText" label="Testo di aiuto verifica">
        <RichTextAdvancedInput
          name="layout.endHelpText"
          menus={MenuPresets.Minimal}
          rows={3}
        />
      </FormItem>
    </div>
  );
}
